import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import { SETTING_NAMES } from 'common/constants/constants';
import useSettingsService from 'components/hooks/useSettingsService';

export function useDashboardSettings() {
  const { getSettingOrDefinitionValue } = useSettingsService();

  const isHidePersonalInformationDashboardEnabled = getSettingOrDefinitionValue(
    {
      name: FEATURE_FLAGS_NAMES.hidePersonalInformationDashboardEnabled
    }
  );
  const isShowPersonalInformation = getSettingOrDefinitionValue({
    name: SETTING_NAMES.SHOW_PERSONAL_INFORMATION
  });

  const shouldHidePersonalInformationDashboard =
    isHidePersonalInformationDashboardEnabled && !isShowPersonalInformation;

  const isTeamPMConfigurationEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.teamPMConfigurationEnabled
  });

  const isShowTeamOfTeamsDashboard = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.showTeamOfTeamsDashboard
  });

  const isNewTeamDashboardPastIterationEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.newTeamDashboardPastIterationEnabled
  });

  return {
    shouldHidePersonalInformationDashboard,
    isTeamPMConfigurationEnabled,
    isShowTeamOfTeamsDashboard,
    isNewTeamDashboardPastIterationEnabled
  };
}
